import { EntityType } from '@components'

import isEmpty from 'lodash/isEmpty'

import { CustomerType } from '../enums/customerType'
import { Contact } from '../types/contact'
import { ContactType } from '../types/contactType'
import { CustomerForm } from '../types/customerForm'

type BaseCustomerFormData = Pick<
  CustomerForm,
  | 'address'
  | 'companyName'
  | 'customerType'
  | 'eInvoiceAddress'
  | 'entityType'
  | 'firstName'
  | 'id'
  | 'isAddressExempt'
  | 'lastName'
  | 'vatNumber'
>

export const getBaseCustomerPayload = ({
  address,
  companyName,
  customerType,
  eInvoiceAddress,
  entityType,
  firstName,
  id,
  isAddressExempt,
  lastName,
  vatNumber,
}: BaseCustomerFormData): Partial<Contact> => {
  const contactPersonName = `${firstName || ''} ${lastName || ''}`.trim()
  const isCompany = customerType === CustomerType.Company
  const ean = eInvoiceAddress?.address?.trim() || ''
  // If ean is empty string, saving only eInvoiceScheme is not useful.
  // So we need to send empty string for eInvoiceScheme to clear existing value during edit.
  // Using 'undefined' would ignore the field and backend transforms 'null' to empty string.
  // Therefore the type of eInvoiceScheme is (eInvoiceScheme: EInvoiceScheme).
  const eInvoiceScheme = isEmpty(ean) ? '' : eInvoiceAddress?.scheme || ''

  return {
    addressLine2: address?.streetAddress2,
    cityText: address?.city,
    countryId: address?.country,
    ean,
    eInvoiceScheme,
    isAddressExempt,
    name: isCompany ? companyName : contactPersonName,
    publicEntityRoutingEnabled: entityType === EntityType.Public,
    street: address?.streetAddress1,
    type: isCompany ? ContactType.Company : ContactType.Person,
    vatNo: vatNumber,
    zipcodeText: address?.pobox,
    ...(id ? { id } : {}),
  }
}
